import Unauthorize from '../../../../appmodules/error/components/Unauthorize';

export const unauthorizeerror = [
    {
        path: '/unauthorizeerror',
        component: Unauthorize,
    },
];
